import { combine, compute, createInMemoryAtom, dedupe } from '@exodus/atoms'

const mockHasNftsAtom = createInMemoryAtom({ defaultValue: false })

const mockSeedlessAtom = createInMemoryAtom({ defaultValue: { backup: { isUploaded: false } } })

const createAnnouncementsFilterAtom = ({
  shownAnnouncementsAtom,
  shownForcedAnnouncementsAtom,
  backedUpAtom,
  txLogsAtom,
  seedlessAtom,
  balancesAtom,
  hasBalanceAtom,
  hasNftsAtom,
  geolocationAtom,
  walletAccountsAtom,
  config,
}) => {
  const combinedAtom = combine({
    backedUp: backedUpAtom,
    txLogs: txLogsAtom,
    balances: balancesAtom,
    hasBalance: hasBalanceAtom,
    hasNfts: hasNftsAtom || mockHasNftsAtom,
    seedless: seedlessAtom || mockSeedlessAtom,
    shownAnnouncements: shownAnnouncementsAtom,
    shownForcedAnnouncements: shownForcedAnnouncementsAtom,
    geolocation: geolocationAtom,
    walletAccounts: walletAccountsAtom,
  })

  const selector = ({
    shownAnnouncements,
    shownForcedAnnouncements,
    txLogs,
    seedless,
    backedUp,
    balances,
    hasBalance,
    hasNfts,
    geolocation,
    walletAccounts,
  }) => {
    const hasSeedlessBackup = seedless.backup.isUploaded
    const hasBackup = backedUp || hasSeedlessBackup
    const allShownAnnouncements = { ...shownAnnouncements, ...shownForcedAnnouncements }

    return {
      walletAccounts,
      shownAnnouncements: allShownAnnouncements,
      hasBackup,
      hasSeedlessBackup,
      hasBalance,
      hasNfts,
      txLogs: txLogs.value,
      balances: balances.balances,
      countryCode: geolocation.countryCode,
      os: config.os,
      osVersion: config.osVersion,
      platform: config.platform,
      build: config.build,
      version: config.version,
    }
  }

  return dedupe(compute({ atom: combinedAtom, selector }))
}

export default createAnnouncementsFilterAtom
